import type { ReactNode } from 'react';

import { ContentLoadingOverlay } from '../../common/ContentLoadingOverlay/ContentLoadingOverlay';
import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';

interface DemandCardSectionProps {
    children: ReactNode;
    gap?: number;
    columns?: number;
    isLoading: boolean;
}

export const DemandCardSection = ({ children, gap = 12, columns = 3, isLoading }: DemandCardSectionProps) => (
    <Box position="relative">
        <Box display="grid" gridTemplateColumns={`repeat(${columns}, minmax(0, 1fr))`} gap={gap}>
            {children}
        </Box>
        <ContentLoadingOverlay isLoading={isLoading} label={translate('demandDefinition.recalculating')} />
    </Box>
);
